<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <graph-tool-bar :showSource="true" granularity="day" @on-selected="onPanelSelect"></graph-tool-bar>
        </md-card-header>

        <md-card-content>
          <highcharts class="charts" :options="chartOptions" ref="areaChart"></highcharts>
        </md-card-content>
      </md-card>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import graphToolBar from "@/components/GraphToolBar";
import areaChartOptions from "@/config/charts/area";
import axios from "axios";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";
import snackBar from "@/components/SnackBar";

export default {
  components: {
    "graph-tool-bar": graphToolBar,
    "snack-bar": snackBar
  },
  data() {
    return {
      chartOptions: null
    };
  },
  computed: {
    selectedyAxisType() {
      return this.$store.getters.getSettings.yAxisType;
    },
  },

  created() {
    const onyAxisSelect = type => {
      this.$store.commit("setyAxisType", type);
    };

    this.chartOptions = JSON.parse(JSON.stringify(areaChartOptions));
    this.chartOptions.title.text = "Frequency";
    this.chartOptions.yAxis.labels.format = "{value} Hz";
    this.chartOptions.tooltip.pointFormat =
      "<span style='color:{point.color}'>●</span> {series.name}: <b>{point.y} Hz</b><br/>";

        this.chartOptions.series = [{
          name: "Frequency",
          type: "area",
          visible: true,
          marker: {
            enabled: false
          },
          data: []
        }];

    this.chartOptions.legend.enabled = false;
  
    this.chartOptions.yAxis.type = this.selectedyAxisType;
    this.chartOptions.chart.events = {
      redraw: function(event) {
        this.hideLoading();
      }
    };
    this.chartOptions.exporting.buttons.contextButton.menuItems.push(
      "separator"
    );
    this.chartOptions.exporting.buttons.contextButton.menuItems.push({
      textKey: "scalerChange",
      onclick: function() {
        if (this.userOptions.yAxis.type == "logarithmic") {
          this.userOptions.yAxis.type = "linear";
          this.yAxis[0].update({ type: "linear" });
          onyAxisSelect("linear");
        } else {
          this.userOptions.yAxis.type = "logarithmic";
          this.yAxis[0].update({ type: "logarithmic" });
          onyAxisSelect("logarithmic");
        }
      }
    });
  },

  methods: {
    onPanelSelect(data) {
      this.$nextTick(() => {
        this.getAPIData(data);
      });
    },

    getAPIData(selected) {
      const { chart } = this.$refs.areaChart;
      chart.showLoading();

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + ( (selected.device.type === 12) ? "/profileEY" : "/profile"),
        data: {
          token: getSelectedDeviceToken(selected.device.mac),
          data: "F",
          phase: "L1,L2,L3",
          from: selected.date.from,
          to: selected.date.to,
          format: "H"
        },
        withCredentials: true
      })
        .then(response => {
          chart.series[0].setData(response.data.data.F, false, false, false);
          chart.xAxis[0].setExtremes(null, null, true);
        })
        .catch(error => {
          if (error.response.data.code == 610) {
            this.$refs.snackbar.notify(this.$lang.messages.data_not_found);
            chart.series[0].setData([]);

          } else {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-layout {
  margin-top: -29px;
}
</style>